import React from 'react'
// import ReactPlayer from 'react-player/youtube'

import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import { youtubeGetID } from '../../helpers/getYoutubeUrlId'

// import VotingPlayer from './VotingPlayer'

const styles = (theme) => ({
  heading: {
    backgroundColor: theme.palette.secondary.main,
    color: '#ffffff',
  },
  headingTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  content: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  field: {
    marginBottom: theme.spacing(1),
    wordBreak: 'break-word',
  },
  player: {
    display: 'flex',
    border: 'none',
    height: 480,
    width: 858,
    [theme.breakpoints.down('md')]: {
      height: 394,
      width: 700,
    },
    [theme.breakpoints.down('sm')]: {
      height: 346,
      width: 615,
    },
    [theme.breakpoints.down('xs')]: {
      height: 263,
      width: 350,
    },
  },
})
const useStyles = makeStyles(styles)

export default function VotingDemoVideo(props) {
  const { link, title } = props
  const demoVideoId = youtubeGetID(link)

  const classes = useStyles()

  return (
    <Accordion expanded>
      <AccordionSummary className={classes.heading}>
        <Typography className={classes.headingTitle}>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <div className={classes.content}>
          <iframe
            className={classes.player}
            src={`https://www.youtube.com/embed/${demoVideoId}`}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />

          {/* <ReactPlayer url={link} /> */}
        </div>
      </AccordionDetails>
    </Accordion>
  )
}
